<tr class="wa-table__row wa-table__row--no-border-bottom">
  <td class="wa-table__cell wa-table__cell--span-highlight" colspan="100%">
    <span class="uppertext-black-no-viewport inline">{{Ranking.name }} - </span>
    <span class="uppertext-no-viewport inline">
      {{Ranking.subname}}
    </span>
  </td>
</tr>
<tr class="wa-table__row visibility--hide-mobile">
  <td class="wa-table__cell wa-table__cell--fit-right">
    <div class="ranking ranking--fit" data-th="ranking" [ngClass]="{'ranking--square': Ranking.athlete !== undefined}">
      <div *ngIf="Ranking.athlete !== undefined; else: teamimage" class="ranking__picture">
        <img [lazyLoad]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + Ranking?.athlete?.id" />
      </div>
      <ng-template #teamimage>
        <div class="ranking__picture">
          <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.noc + '.svg'" />
        </div>
      </ng-template>
    </div>
  </td>
  <td *ngIf="Ranking.athlete === undefined" class="wa-table__cell">
    <div class="squad" data-th="team">
      <div class="squad__name">{{ Ranking?.teamName}}</div>
    </div>
  </td>
  <td class="wa-table__cell">
    <a [href]="lang + 'athlete/'+Ranking?.athlete?.id.toString()" *ngIf="Ranking.athlete" class="athlete" data-th="name">
      <div [ngClass]="Ranking.athlete.wNameOrd === 1 ? 'athlete__lastname' : 'athlete__name'">
        {{
        Ranking.athlete.wNameOrd === 1
        ? Ranking.athlete.fName
        : Ranking.athlete.gName
        }}</div>
      <div [ngClass]="Ranking.athlete.wNameOrd === 0 ? 'athlete__lastname' : 'athlete__name'">
        {{
        Ranking.athlete.wNameOrd === 0
        ? Ranking.athlete.fName
        : Ranking.athlete.gName
        }}</div>
      <div class="athlete__img" *ngIf="Ranking.athlete.noc!==undefined">
        <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.athlete.noc + '.svg'" />
      </div>
    </a>
  </td>

  <td class="wa-table__cell">
    <ng-template #team>
      <div class="squad" data-th="team">
        <div *ngFor="let archer of Ranking.archers">
          <div class="squad__name" [ngClass]=" archer.wNameOrd === 1 ? 'squad__lastname' : 'squad__name'">
            {{
            archer.wNameOrd === 1
            ? archer.fName
            : archer.gName
            }}
          </div>
          <div class="squad__lastname" [ngClass]="archer.wNameOrd === 0 ? 'squad__lastname' : 'squad__name'">
            {{
            archer.wNameOrd === 0
            ? archer.fName
            : archer.gName
            }}
          </div>
        </div>
      </div>
    </ng-template>
  </td>
  <td class="wa-table__cell">
    <div class="competition" data-th="competition">
      <a [href]="lang + 'competition/'+Ranking?.competition?.id.toString()" class="competition__name">{{Ranking.competition?.name !== '' && Ranking.competition?.name ? Ranking.competition?.name : '' }}</a>
      <div>
        <div class="competition__date">{{Ranking.date | date : 'dd MMMM yyyy'}}</div>
        <div class="competition__place">{{Ranking.competition?.place}}</div>
        <div class="competition__country" *ngIf="Ranking.competition?.country">
          <div class="competition__country__flag">
            <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.competition?.country + '.svg'" />
          </div>
          <div class="competition__country__name">{{ getNameCountry(Ranking.competition.country) }}</div>
        </div>
      </div>
    </div>
  </td>
  <td class="wa-table__cell">
    <div class="score" data-th="points">
      <span [ngClass]="{'score__secondary':Ranking.points!==Ranking.maxPoints}">{{Ranking.points}} <span *ngIf="Ranking.maxPoints!==undefined && Ranking.points===Ranking.maxPoints">{{Ranking.xs}}X
        </span></span><span *ngIf="Ranking?.maxPoints.toString()!==''">/</span><span *ngIf="Ranking?.maxPoints.toString()!==''">
        {{Ranking.maxPoints}}</span>
    </div>
  </td>
  <td class="wa-table__cell wa-table__cell--fit-left">
    <div class="list-row-item__action" (click)="onClick()">
      <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
      </span>
    </div>
  </td>
</tr>

<div class="wa-table-simple visibility--hide-desktop">
  <div class="wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">
      <div class="ranking ranking--fit" data-th="ranking" [ngClass]="{'ranking--square': Ranking.athlete !== undefined}">
        <div *ngIf="Ranking.athlete !== undefined; else: teamimage" class="ranking__picture">
          <img [lazyLoad]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + Ranking?.athlete?.id" />
        </div>
        <ng-template #teamimage>
          <div>
            <div class="ranking__picture">
              <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.noc + '.svg'" />
            </div>
            <div *ngIf="Ranking.athlete === undefined" class="visibility--hide-desktop">
              <div class="squad" data-th="team">
                <div class="squad__name">{{ getNameCountry(Ranking.noc)}}</div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">
      <a [href]="lang + 'athlete/'+Ranking?.athlete?.id.toString()" *ngIf="Ranking.athlete" class="athlete" data-th="name">
        <div [ngClass]="Ranking.athlete.wNameOrd ===1 ? 'athlete__lastname' : 'athlete__name'">
          {{
          Ranking.athlete.wNameOrd === 1
          ? Ranking.athlete.fName
          : Ranking.athlete.gName
          }}
        </div>
        <div [ngClass]="Ranking.athlete.wNameOrd === 0 ? 'athlete__lastname' : 'athlete__name'">
          {{
          Ranking.athlete.wNameOrd === 0
          ? Ranking.athlete.fName
          : Ranking.athlete.gName
          }}
        </div>
        <div class="athlete__img" *ngIf="Ranking.athlete.noc!==undefined">
          <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.athlete.noc +'.svg'" />
        </div>
      </a>
    </div>
    <div class="wa-table-simple__cell__item">
      <ng-template #team>
        <div class="squad" data-th="team">
          <div *ngFor="let archer of Ranking.archers">
            <div class="squad__name" [ngClass]=" archer.wNameOrd === 0 ? 'highlight' : ''">
              {{
              archer.wNameOrd === 1
              ? archer.fName
              : archer.gName
              }}
            </div>
            <div class="squad__lastname" [ngClass]="archer.wNameOrd === 0 ? 'highlight' : ''">
              {{
              archer.wNameOrd === 1
              ? archer.fName
              : archer.gName
              }}
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="wa-table-simple__cell__item">
      <div class="competition" data-th="competition">
        <div class="competition__name">{{Ranking.competition?.name !== '' && Ranking.competition?.name ? Ranking.competition?.name : ''}}</div>
        <div>
          <div class="competition__date"> {{Ranking.date | date : 'dd MMMM yyyy'}}</div>
          <div class="competition__place">{{Ranking.competition?.place}}</div>
          <div class="competition__country" *ngIf="Ranking.competition?.country">
            <div class="competition__country__flag">
              <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.competition?.country + '.svg'" />
            </div>
            <div class="competition__country__name">{{ getNameCountry(Ranking.competition.country) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wa-table-simple__cell wa-table-simple__cell--right">
    <div class="wa-table-simple__cell__item">
      <div class="score score--extra-small-double" data-th="points">
        <span [ngClass]="{'score__secondary':Ranking.points!==Ranking.maxPoints}">{{Ranking.points}} <span *ngIf="Ranking.maxPoints!==undefined && Ranking.points===Ranking.maxPoints">{{Ranking.xs}}X
        </span></span><span *ngIf="Ranking?.maxPoints.toString()!==''">/</span><span *ngIf="Ranking?.maxPoints.toString()!==''">
        {{Ranking.maxPoints}}</span>
      </div>
    </div>
    <div class="wa-table-simple__cell__item">
      <div class="list-row-item__action" (click)="onClick()">
        <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
        </span>
      </div>
    </div>
  </div>
</div>

<tr class="wa-table__row wa-table__row--simple">
  <td class="wa-table__cell wa-table__cell--fit" colspan="100%">

  <div *ngIf="showDetails">
    <!--
      Commented for use in the future migration of styles and designs.
      <app-athlete-records-history [recordArea]="Ranking.areaId" [recordLevel]="Ranking.levelId" [recordType]="Ranking.typeId"></app-athlete-records-history>

      </div>
      <ng-template #team>
        <app-world-records-detail *ngIf="showDetails" [allData]="recordHistory"></app-world-records-detail>
      </ng-template>

    -->
   <app-world-records-detail [allData]="recordHistory" *ngIf="showDetails === true"></app-world-records-detail>
   </div>
  </td>
</tr>
